const en = {
    common:{
        understandDeeply:"Insight",
        installationGuide:"Installation Guide",
        downloadMaterials:"Material",
        helpAndSupport:"Help and Support",
        followUs:"Follow us",
        downloadVedio:"Download",
        downloading:"Downloading...",
        gallery:"Gallery",
        customer:"Customer Service Kang Kang",
        customerContent:"You can ask me if you have any questions",
        product:"Automotive Consumer Products",
        search:"search",
        searchPlaceholder:"Please enter the search keyword",
        historySearch:"Search History",
        loading:"loading...",
        cancel:"cancel",
        noData:"No Data",
        confirmDelete:"Confirm delete all history",
        downloadFail:"Download Fail",
        confirmDownload:"Confirm Download",
        closeMessage:"Tap the screen to close the guide",
        vedio:"Vedio",
        picture:"Picture"
    }
}
export default en;


// WEBPACK FOOTER //
// ./src/i18n/langs/en.js